export const PHONE_CARD_FORM_CRITERIA = {
  CARD_CODE_LENGTH: 15,
  CARD_SERIAL_MIN_LENGTH: 10,
  CARD_SERIAL_MAX_LENGTH: 20,
  NUMBER_OF_PHONE_CARD_MAX: 15,
  LENGTH_OF_PHONE_CARD_MAX: 2
}
